import React, { FC } from 'react';
import styled from 'src/theme';

interface Props {
  text: string;
  isVisible?: boolean;
  isDisabled?: boolean;
  isLastStep?: boolean;
}

export const StepHeader: FC<Props> = ({
  isVisible = true,
  isDisabled = false,
  isLastStep = false,
  ...props
}) => (
  <ViewStyled>
      <TextStyled>
        {props.text}
      </TextStyled>
  </ViewStyled>
);

const ViewStyled = styled.div`
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  @media screen and ${props => props.theme.media.tablet} {}
  @media screen and ${props => props.theme.media.mobile} {}
`;

const TextStyled = styled.span`
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border-bottom: 2px solid ${props => props.theme.colors.orange};
  color: ${props => props.theme.colors.nero};
  @media screen and ${props => props.theme.media.mobile} {}
`;

